import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import LocomotivePosition from '@/models/LocomotivePosition'
import Locomotive from '@/models/Locomotives/Locomotive'
// import LocoSectionWithParameters from '@/models/Graph/LocoSectionWithParameters'
import ParameterForGraph from '@/models/Graph/ParameterForGraph'
import LocoSectionError from '@/models/LocomotiveError'

@Module({name: 'LocomotivesModule'})
export default class LocomotivesModule extends VuexModule {
    _locomotivesPositions = Array<LocomotivePosition>()
    _locomotivesData = Array<Locomotive>()
    _lastLocomotiveParameters = new Array<ParameterForGraph>()
    _locoSectionErrors = new Array<LocoSectionError>()
    // _locomotivesParameters = new LocoSectionWithParameters()

    @Mutation
    setLocomotivesPositions(locomotivesPositions: Array<LocomotivePosition>) {
        this._locomotivesPositions = locomotivesPositions
    }

    @Mutation
    setLocomotivesData(locomotivesData: Array<Locomotive>) {
        this._locomotivesData = locomotivesData
    }

    @Mutation
    setLocomotivesParameters(locomotivesParameters: Array<ParameterForGraph>) {
        this._lastLocomotiveParameters = locomotivesParameters
    }

    @Mutation
    addLocoSectionError(locoSectionError: LocoSectionError) {
        this._locoSectionErrors.push({
            error: locoSectionError.error,
            locoSection: locoSectionError.locoSection
        })
    }

    // @Mutation
    // fillLocomotivesParameters(locomotivesParameters: LocoSectionWithParameters) {
    //     this._locomotivesParameters.locoSection = locomotivesParameters.locoSection
    //     locomotivesParameters.parameters.forEach((p) => {
    //         this._locomotivesParameters.parameters.push(p)
    //     })
    // }

    @Action
    updateLocomotivesPositions(locomotivesPositions: Array<LocomotivePosition>) {
        this.context.commit('setLocomotivesPositions', locomotivesPositions)
    }

    @Action
    updateLocomotivesData(locomotivesData: Array<Locomotive>) {
        debugger;
        this.context.commit('setLocomotivesData', locomotivesData)
    }

    // @Action
    // updateLocomotivesParameters(locomotivesParameters: LocoSectionWithParameters) {
    //     this.context.commit('setLocomotivesParameters', locomotivesParameters.parameters)
    // }

    // @Action
    // async getLastLocomotivesParameters(request: any): Promise<any> {
    //     const url = `/api/v1/OnlineLocomotiveParameters?locoSection=${request.locoSection}&from=${request.dateFrom.toISOString()}&to=${request.dateTo.toISOString()}`
    //     const params = await (await fetch(url)).json()
    //     this.context.commit('fillLocomotivesParameters', params)
    // }

    get locomotivesPositions() {
        return this._locomotivesPositions
    }

    get locomotivesData() {
        return this._locomotivesData
    }

    get lastLocomotiveParameters() {
        return this._lastLocomotiveParameters
    }

    get locoSectionErrors() {
        return this._locoSectionErrors
    }
}
